import React, { useRef, useState } from "react";
import { Input, Space, Table, Button } from "antd";
import Style from "./OrderPreparedTable.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
const OrderPreparedTable = ({ showModal, data, showOrder, showdelivery }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شخص",
      dataIndex: "person",
      key: "person",
      width: "14%",
      ...getColumnSearchProps("person", "شخص"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showModal(record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شهر",
      dataIndex: "city",
      key: "city",
      width: "13%",
      ...getColumnSearchProps("city", "شهر"),
    },
    {
      title: "شماره سفارش",
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: "15.3%",
      ...getColumnSearchProps("orderNumber", "شماره سفارش"),
    },
    {
      title: "زمان سفارش",
      dataIndex: "date",
      key: "date",
      width: "15.3%",
    },
    {
      title: "نام فروشگاه",
      dataIndex: "shopName",
      key: "shopName",
      width: "15.3%",
      ...getColumnSearchProps("shopName", "نام فروشگاه"),
    },
    {
      title: "لیست سفارش",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "14%",
      render: (text, record) => (
        <button onClick={() => showOrder(record)} className={Style.orderBtn}>
          نمایش سفارش
        </button>
      ),
    },
    {
      title: "عملیات ",
      dataIndex: "action",
      key: "action",
      width: "13%",
      render: (text, record) => (
        <button
          onClick={() => showdelivery(record)}
          className={Style.themeColor}
        >
          اختصاص پیک
        </button>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        loading={data===undefined ? true : false}
        pagination={{
          pageSize: 8,
          // onChange: (page) => onShowSizeChange(page),
          // current:isNaN(page)?1:page,
        }}
        columns={columns}
        dataSource={data}
        scroll={{x:1500, y: 300 }}
        size={"middle"}
        responsive={true}
      />
    </div>
  );
};

export default OrderPreparedTable;
